import React from 'react';
import { useTranslation } from 'react-i18next';

interface AuthFooterProps {
  className?: string;
  children?: React.ReactNode;
}

/**
 * Footer component for authentication pages (User Login, Activate, Forgot Password, Reset Password)
 * Based on Figma design with secure connection indicator
 */
const AuthFooter: React.FC<AuthFooterProps> = ({ className = '', children }) => {
  const { t } = useTranslation();
  if (children) {
    return <footer className={`w-full ${className}`}>{children}</footer>;
  }

  return (
    <footer
      className={`flex flex-col items-center justify-center h-full min-h-0 relative w-full py-1.5 sm:py-2 px-2 sm:px-3 ${className} border-t border-white/10`}
      style={{
        backgroundColor: 'var(--footer-background, rgba(5, 11, 24, 0.8))',
      }}
    >
      <div
        className="inline-flex items-center gap-1.5 sm:gap-2 py-1 sm:py-1.5 px-2.5 sm:px-3 md:px-4 rounded-full"
        style={{
          backdropFilter: 'blur(8px)',
          WebkitBackdropFilter: 'blur(8px)',
          backgroundColor: 'rgba(255,255,255,0.05)',
          border: '1px solid rgba(255,255,255,0.1)',
          boxShadow: '0 4px 16px rgba(0,0,0,0.3)',
        }}
      >
        <div
          className="flex-shrink-0 rounded-full bg-[#10b981] w-1.5 h-1.5"
          aria-hidden
        />
        <span className="text-white/80 text-[9px] sm:text-[10px] font-black tracking-wider whitespace-nowrap" style={{ letterSpacing: '0.08em' }}>
          {t('authFooter.secureConnectionEstablished')}
        </span>
      </div>
    </footer>
  );
};

export default AuthFooter;
